/**
 * Table Component
 *
 * Props:
 * - dataSource
 * - columns
 * - style
 */
import React from "react";
import { Table } from "antd";
import PropTypes from "prop-types";

const TableComponent = (props) => {
  return <Table rowKey={(row) => row.id} {...props} />;
};

// Declare data type for props
TableComponent.propTypes = {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

export default TableComponent;
